import { useState } from 'react'
import { API_URL, fetchOptions } from 'store/fetchUtils'

// const API_URL = window.REACT_APP_API_URL

// const fetchOptions = ({ session, body, ...options }) => ({
// 	headers: {
// 		'Content-Type': 'application/json',
// 	},
// 	mode: 'cors',
// 	body: body ? JSON.stringify(body) : undefined,
// 	...(options || {}),
// })

const useForgotPassword = () => {
	const [sendingInfo, setSendingInfo] = useState(false)
	const [error, setError] = useState(null)
	const [success, setSuccess] = useState(null)

	const resetPassword = (username, password, rememberMe) => {
		setSendingInfo(() => {
			setError(null)
			setSuccess(false)
			return true
		})
		return fetch(
			`${API_URL}/api/session/forgot_password`,
			fetchOptions({
				method: 'POST',
				body: { username },
			})
		)
			.then((response) => {
				if (response.ok) {
					setSuccess(() => {
						setSendingInfo(false)
						setError(null)
						return true
					})
					return true
				} else {
					setError(() => {
						setSendingInfo(false)
						return {
							message: response.message || response.statusText,
						}
					})
				}
			})
			.catch((e) => {
				setSuccess(() => {
					setSendingInfo(false)
					setError(e)
					return null
				})
				throw e
			})
	}

	return [success, sendingInfo, error, resetPassword]
}

export default useForgotPassword
